// Собирает npm run generate:unit-footprints, руками не править.
// Рамка содержимого каждого кадра листа следов, порядок — FOOTPRINT_SHEET.frames:
// слева, сверху, справа, снизу, в точках кадра
export const FOOTPRINT_FRAME_BOUNDS = [
  [29, 10, 67, 86],
  [32, 10, 64, 86],
  [28, 10, 68, 86],
  [26, 10, 70, 86],
  [22, 10, 74, 86],
  [13, 10, 83, 86],
  [17, 10, 79, 86],
  [24, 10, 72, 86],
  [30, 10, 66, 86],
  [27, 10, 69, 86],
  [24, 10, 72, 86],
  [21, 10, 76, 86],
  [21, 10, 76, 86],
  [16, 10, 81, 86],
  [25, 10, 71, 86],
  [26, 10, 70, 86],
  [15, 10, 81, 86],
  [26, 10, 71, 86],
  [20, 10, 77, 86],
  [18, 10, 78, 86],
  [12, 10, 85, 86],
  [10, 15, 86, 82],
  [17, 10, 80, 86],
  [12, 10, 84, 86],
  [22, 10, 75, 86],
  [23, 10, 73, 86],
  [10, 13, 86, 83],
  [33, 0, 63, 96],
  [39, 10, 57, 86],
  [21, 10, 75, 86],
  [2, 2, 94, 94],
  [24, 10, 72, 86],
  [11, 11, 85, 91],
  [11, 8, 85, 88],
  [20, 10, 75, 88],
  [12, 12, 85, 81],
  [10, 10, 86, 86],
  [8, 8, 88, 88],
  [1, 1, 95, 95],
  [2, 2, 94, 94],
  [6, 6, 90, 90],
  [1, 7, 95, 89],
  [9, 4, 87, 92],
  [41, 0, 55, 94],
  [22, 10, 74, 90],
  [29, 13, 66, 83],
  [19, 19, 77, 80],
  [29, 13, 67, 86],
  [19, 11, 79, 86],
  [0, 8, 96, 93],
  [0, 3, 96, 91],
  [14, 11, 82, 87],
  [2, 2, 94, 94],
  [19, 0, 77, 96],
  [22, 1, 74, 95],
  [18, 0, 78, 96],
  [16, 0, 80, 96],
  [12, 3, 84, 94],
  [3, 1, 93, 96],
  [7, 1, 89, 95],
  [14, 2, 82, 96],
  [21, 1, 76, 95],
  [17, 1, 78, 96],
  [14, 1, 81, 96],
  [12, 0, 85, 96],
  [11, 3, 86, 96],
  [6, 3, 91, 93],
  [16, 3, 81, 95],
  [16, 2, 80, 95],
  [6, 0, 90, 96],
  [16, 3, 81, 95],
  [10, 2, 86, 95],
  [8, 1, 88, 95],
  [2, 1, 95, 96],
  [2, 7, 94, 91],
  [8, 2, 90, 95],
  [2, 2, 94, 96],
  [12, 2, 85, 95],
  [13, 2, 83, 95],
  [2, 5, 94, 92],
  [23, 0, 73, 96],
  [31, 2, 65, 94],
  [12, 0, 83, 96],
];
